<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import BaseChart from '@/charts/BaseChart.vue'

const props = defineProps<{
	  used: number
	  total: number
}>()

const chartOptions = computed(() => ({
	  tooltip: {
		      trigger: 'item'
		    },
	  legend: {
		      top: '5%',
		      left: 'center'
		    },
	  series: [
		      {
			            name: 'Storage Usage',
			            type: 'pie',
			            radius: ['40%', '70%'],
			            avoidLabelOverlap: false,
			            itemStyle: {
					            borderRadius: 10,
					            borderColor: '#fff',
					            borderWidth: 2
					          },
			            label: {
					            show: false,
					            position: 'center'
					          },
			            emphasis: {
					            label: {
							              show: true,
							              fontSize: '18',
							              fontWeight: 'bold'
							            }
					          },
			            labelLine: {
					            show: false
					          },
			            data: [
					            { value: props.used, name: 'Used' },
					            { value: props.total - props.used, name: 'Free' }
					          ],
			            color: ['#ef4444', '#22c55e']
			          }
		    ]
}))
</script>

<template>
	  <div class="h-full w-full flex flex-col">
		      <div class="text-center mb-2">
			            <h3 class="font-semibold">Storage Usage</h3>
				          <p class="text-sm text-gray-500">
					          {{ (props.used / 1024 / 1024 / 1024).toFixed(2) }} GB of {{ (props.total / 1024 / 1024 / 1024).toFixed(2) }} GB
						        </p>
							    </div>
							        <BaseChart :options="chartOptions" class="flex-1" />
								  </div>
</template>
